import { z } from 'zod';
import { getText } from '@educaplay/app-core/language';
import { checkNIF } from '../helpers/functions';

export const BLOCKED_CIFS = ['B26529560', 'B26265835'];
export const VAT_VALID_CHARS_REGEX = /^[A-Za-z0-9\s\-.]+$/;

export const hasVatFormatError = (vatNumber) => {
    if (!vatNumber) return false;
    if (!VAT_VALID_CHARS_REGEX.test(vatNumber)) return true;
    if (BLOCKED_CIFS.includes(vatNumber.toUpperCase())) return true;
    return false;
};

export const getBillingSchema = () => {
    return z.object({
        country: z.string().min(1, { message: getText('error_field_empty') }),
        name: z.string().min(1, { message: getText('error_field_empty') }),
        vat_number: z.string().min(1, { message: getText('error_field_empty') }).max(20, { message: getText('error_field_wrong_vat_number') }),
        address: z.string().min(1, { message: getText('error_field_empty') }),
        town: z.string().min(1, { message: getText('error_field_empty') }),
        province: z.string().min(1, { message: getText('error_field_empty') }),
        zip_code: z.string().min(1, { message: getText('error_field_empty') }),
    }).superRefine((data, ctx) => {
        if (data.vat_number) {
            if (!/^[A-Za-z0-9\s\-.]+$/.test(data.vat_number)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: getText('error_field_wrong_vat_number'),
                    path: ['vat_number'],
                });
                return;
            }

            const EducaplayCIF = 'B26529560';   
            const ADRFormacionCIF = 'B26265835';
            const blockedCifs = [EducaplayCIF, ADRFormacionCIF];
            if (blockedCifs.includes(data.vat_number.toUpperCase())) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: getText('error_field_wrong_vat_number'),
                    path: ['vat_number'],
                });
                return;
            }
        }

        if (data.country === 'ES' && data.vat_number) {
            if (!checkNIF(data.vat_number)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: getText('error_field_wrong_vat_number'),
                    path: ['vat_number'],
                });
            }
        }
    });
};

export const getDefaultBillingValues = (initialData = {}) => ({
    country: initialData?.country ?? '',
    name: initialData?.name ?? '',
    vat_number: initialData?.vat_number ?? '',
    address: initialData?.address ?? '',
    town: initialData?.town ?? '',
    province: initialData?.province ?? '',
    zip_code: initialData?.zip_code ?? '',
});
